import { useState } from "react"
import Box from "@mui/material/Box"
import CustomButton from "@/components/custom-button"
import { useResetTuyaConnection } from "@/hooks/use-tuya"


export default function TuyaResetConnectionButton() {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    const mutation = useResetTuyaConnection()

    return (
        <Box>
            <Box display="flex" justifyContent="center" gap={1}>
                {!confirmation &&
                    <CustomButton
                        variant="outlined"
                        color="error"    
                        text="Resetovat propojení účtu"
                        onClick={() => setConfirmation(true)}
                    />
                }
                {confirmation &&
                    <>
                        <CustomButton
                            color="error" 
                            text="Potvrdit"
                            disabled={mutation.isPending}
                            onClick={() => mutation.mutate()}
                        />
                        <CustomButton
                            variant="outlined"
                            text="Zrušit"
                            onClick={() => setConfirmation(false)}
                        />
                    </>
                }
            </Box>
            <Box>
                {mutation.isError ? (
                    <div>Došlo k chybě: {mutation.error.message}</div>
                ) : null}
            </Box>
        </Box>
    )
}
